<img
  class="logo"
  [src]="asset('assets/images/ibk-logo.svg')"
  alt="Interbank logo">

<h2 class="title f-regular">
  Abre tu Cuenta Negocios 100% digital y <b>¡comienza a recibir tus pagos!</b></h2>

<ul class="check-list">
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content">
      Abre tu Cuenta Negocios <b class="f-bold">¡Sin
      trámites ni papeleos!</b>
    </span>
  </li>
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content">
      Accede a la Banca por Internet Empresas sin costo.
    </span>
  </li>
  <li class="check-list__item">
    <ibk-icon class="bullet">check</ibk-icon>
    <span class="content">
      Realizaremos un cobro de S/ 75 o USD 25 para la validación
      de títulos de SUNARP.
    </span>
  </li>
</ul>

<section class="user-info">
  <img
    [src]="asset('assets/images/phone-guy.svg')"
    alt="Interbank info"
    class="user-info__icon">
  <div class="user-info__data">
    <span class="data__item">RUC: {{ ruc }}</span>
    <b class="data__item f-bold">{{ name }}</b>
  </div>
</section>

<button
  class="ibk-btn ibk-btn--primary ba-btn"
  (click)="start()">
  Comencemos
</button>
